import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { createNewCollection } from "../../../store/userCollectionsSlice/collections-actions";

import classes from "./NewCollectionModal.module.css";

const NewCollectionModal = ({ close, url }) => {
  const descRef = useRef();
  const [name,setName] = useState("");
  const [nameLen, setNameLen] = useState(15);

  const dispatch = useDispatch();

  const cancelHandler = () => {
    close();
    setName("");
    descRef.current.value = "";
  };
  const collectionHandler = (e) => {
    e.preventDefault();
    const description = descRef.current.value;
    dispatch(createNewCollection({ name, description }));
    close();
    setName("");
    descRef.current.value = "";
  };

  const changeHandler = (e) => {
    const len = e.target.value.length;
    const left = 15 - Number(len);
    if (left > -1){
      setName(e.target.value);
      setNameLen(left);
    } 
  }
  return (
    <>
      <div className={classes.backdrop} onClick={close} />
      <div className={classes.overlay}>
        <img src={url} alt="opened img used as placeholder" />
        <div className={classes.details}>
          <h2 className={classes.title}>Add New Collection</h2>
          <form>
            <section className={classes.section}>
              <label htmlFor="name">Name</label>
              <input value={name}id="name" placeholder="pretty sky" onChange={changeHandler} />
              <span className={classes.count}>{nameLen}</span>
            </section>
            <section className={classes.section}>
              <label htmlFor="description">
                Description<span>(optional)</span>
              </label>
              <textarea rows="3" ref={descRef} id="description" />
            </section>
            <div className={classes.actions}>
              <button type="button" onClick={cancelHandler} className={classes[`sec-btn`]}>
                Cancel
              </button>
              <button onClick={collectionHandler} disabled={!(nameLen>0)} className={classes[`primary-btn`]}>Create Collection</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NewCollectionModal;
